<template>
  <div class="container-image-gallery">
    <div class="">
      <div class="row">
        <div class="col-12">
          <div :id="imageGalleryId" class="carousel slide carousel-fade" data-ride="carousel" data-interval="false">
            <div ref="carousel-inner" class="carousel-inner">
              <div  class="carousel-item" :class="{'active':key==0}" :key="`photo_${key}`" v-for="(photo, key) in items">
                <ImageInline format="content-fit" :src="photo.photo"/>
              </div>            
            </div>
            <a class="carousel-control-prev" :href="`#${imageGalleryId}`" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" :href="`#${imageGalleryId}`" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss">

  .container-image-gallery {
    position: relative;
    left: -20%;
    width: 140%;
    height: auto;
    margin: 15vh auto 10vh auto;
    overflow: hidden;

    @media (max-width: 820px) {
      left: -20px;
      width: calc(100% + 40px);
    }

    .carousel-control-next, .carousel-control-prev {
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15%;
      padding: 0;
      color: #fff;
      text-align: center;
      background: 0 0;
      border: 0;
      opacity: .5;
      transition: opacity .15s ease;
      max-height: 580px;

      @media (max-width: 600px) {
        max-height: 250px;
      }
    }

    .container-image-inline-item {
      margin: 0;
    }

    .legend {
      width: 100%;
    }

    .carousel-indicators {
      position: absolute;
      display: block;
      left: inherit;
      right: 0 !important;
      width: 100%;
      max-width: 520px;
      height: 55px;
      margin: 0;
      padding: 0 10px;
      text-align: right;

      li {
        display: inline-block;
        width: 40px;
        
        img {
          border: solid 2px #fff;
        }
      }
    }
  }

</style>

<script>


import ImageInline from '@/components/ImageInline'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import * as Bootstrap from 'bootstrap'

export default {
  name: 'ImageGallery',
  data() {
    return {
      imageGalleryId: `image_gallery_iline_${this._uid}`
    }
  },
  props: {
    items:[]
  },
  components: {
    ImageInline
  },
  mounted() {
    var myCarousel = document.querySelector(`#${this.imageGalleryId}`)
    new Bootstrap.Carousel(myCarousel)
  }
}

</script>
